import ActionButton from 'components/ActionButton';
import AddItemKeywordsModal from 'components/AddItemKeywordsModal';
import { Loading } from 'components/loading/Loading';
import MiniTag from 'components/MiniTag';
import React, { useEffect, useState } from 'react';
import { getKeywords, removeKeywords } from 'services';
import { USER_ROLES, isUserAuthorized, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const ItemKeywords = props => {
  const [addKeywordModalOpen, setAddKeywordModalOpen] = useState<boolean>(false);
  const [keywords, setKeywords] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const {
    itemId,
    userRoles,
  } = props;
  const isUserAuthorizedToEdit = isUserAuthorized(userRoles, [USER_ROLES.PACKER, USER_ROLES.SUPERVISOR, USER_ROLES.MANAGER, USER_ROLES.ADMIN]);

  const fetchKeywords = async () => {
    try {
      const response = await getKeywords(itemId);
      setKeywords(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchKeywords();
  }, []);
  
  const removeKeywordFn = async (keyword: string) => {
    try {
      const { keywords } = (await removeKeywords({
        id: itemId,
        keywords: [keyword],
      })).toJSON();
      setKeywords(keywords);
      showSuccess('Keyword deleted successfully');
    } catch (e) {
      showError(e);
    }
  }; 
  
  const Keyword = ({ keywordText }: { keywordText: string }) => {
    const [loading, setLoading] = useState<boolean>(false);

    const handleRemove = async () => {
      if (loading) return;
      setLoading(true);
      try {
        await removeKeywordFn(keywordText);
      } catch (e) {
        showError(e);
        setLoading(false);
      }
    };
    
    return (
      <MiniTag
        loading={loading}
        isRemovable={isUserAuthorizedToEdit}
        isItemTag={false}
        label={keywordText}
        onRemove={handleRemove}
      />
    );
  };

  const getEmptyKeywordsSection = () => (
    <div className={styles['empty-keywords-section']}>
      No Keywords added
    </div>
  );
  
  const getKeywordsSection = (keywords: string[]) => keywords.map((keyword, i) => <Keyword key={i} keywordText={keyword} />);
  
  return (
    <div className={styles['item-keywords-main-container']}>
      {addKeywordModalOpen && (
        <AddItemKeywordsModal
          itemId={itemId}
          onSuccess={setKeywords}
          toggleModal={() => setAddKeywordModalOpen(!addKeywordModalOpen)}
        />
      )}
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Keywords</div>
        {isUserAuthorizedToEdit && <ActionButton
          text={<>Keywords <span className={'ml-3'}>+</span></>}
          active={true}
          isLoading={false}
          onClick={() => setAddKeywordModalOpen(true)}
        />}
      </div>
      {loading ? <Loading type={'mini'} /> : (
        <div className={styles['keywords-container']}>
          {!!keywords.length ? getKeywordsSection(keywords) : getEmptyKeywordsSection()}
        </div>
      )}
    </div>
  );
};

export default ItemKeywords;